<template>
    <div class="card listing-details-card">
        <div class="card-image">
            <figure class="image is-3by2">
                <img 
                    :src="listing.imageURL"
                    :alt="listing.title"
                    class="modal-listing-image">
            </figure>
        </div>
        <div class="card-content">
            <div class="content">
                <h3 class="listing-modal-title">{{ listing.title }}</h3>

                <div class="defects-tags-container">
                    <span
                        class="defect-tag tag is-danger"
                        v-for="tag in this.listing.tags"
                        :key="tag">
                        {{ tag }}
                    </span>
                </div>

                {{ listing.description }}

                <div class="columns buttons-column is-vcentered">
                    <div class="column buttons">
                        <b-button class="modal-button" @click="onMessage" type="is-primary">Message seller</b-button>
                        <b-button class="modal-button" @click="onDiscard" type="is-danger">Discard listing</b-button>
                    </div>

                    <div class="column price-column">
                        <p class="is-size-4 has-text-primary">{{ this.listing.price }} €</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: "ListingModalContent",
  props: {
      modalActive: {
          type: Boolean,
          default: false
      },
      listing: {
          type: Object,
          required: true
      },
      listingIndex: {
          type: Number,
          required: true,
      },
      queryIndex: {
          type: Number,
          required: true,
      }
  },
  methods: {
    onMessage () {
        window.open(this.listing.messageURL, "_blank");
    },
    onDiscard () {
        this.$emit('discarded', this.queryIndex, this.listingIndex)
    }
  }
};

</script>

<style lang="scss" scoped>

.modal-listing-image {
    object-fit: contain;
    background-color: rgba(0, 0, 0, 192);
}

.buttons-column {
    margin-top: 0.6666em;
}

.buttons-column .column {
    margin-bottom: 0px;
}

.defects-tags-container {
    margin-bottom: 8px;
    margin-top: 8px;
}

.defect-tag {
    margin-right: 8px;
}

.listing-modal-title {
    margin-bottom: 0px;
}

.modal-button {
    margin-bottom: 0px;
}

.price-column {
    text-align: right;
    padding-right: 24px;
}

</style>